module.exports = __webpack_public_path__ + "img/arrows-maximize.32697267.svg";